(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/animations.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/animations.js');
"use strict";


const productCardImageAnimation = (el, delay) => {
  const tl = gsap.timeline(delay);
  tl.to(el, {
    scale: 0.8,
    ease: 'quad.in',
    duration: 0.1,
    rotation: gsap.utils.random(-50, -30, 1)
  });
  tl.to(el, {
    rotation: gsap.utils.random(50, 30, 1),
    duration: 0.1
  });
  tl.to(el, {
    duration: 0.1,
    rotation: gsap.utils.random(-20, -10, 1)
  });
  tl.to(el, {
    scale: 1,
    ease: 'back.out(4)',
    rotation: 6,
    duration: 0.2
  });
  return tl;
};
const miniCartOnRenderBounce = (el, delay) => {
  const tl = gsap.timeline(delay);
  tl.to(el, {
    scale: 1.4,
    duration: 0.2
  });
  tl.to(el, {
    scale: 0.6,
    duration: 0.1
  });
  tl.to(el, {
    scale: 1.2,
    duration: 0.1
  });
  tl.to(el, {
    scale: 1,
    duration: 0.8,
    ease: 'elastic.out(1.6)'
  });
  return tl;
};
const miniCartBounce = el => {
  const tl = gsap.timeline();
  tl.to(el, {
    scale: 1.3,
    duration: 0.1
  });
  tl.to(el, {
    scale: 1,
    duration: 0.6,
    ease: 'elastic.out(1.2)'
  });
  return tl;
};
svs.tickets_giftshop.products.animations = {
  productCardImageAnimation,
  miniCartBounce,
  miniCartOnRenderBounce
};

 })(window);